import cn from "@/v2-ui/utils/utils.cn"
import { useThemeContext } from "@/v2-ui/theme/theme.context"
import { findThemeColorByName } from "@/v2-ui/theme/theme.baseColors"
import {
  THEME_MODE_OPTIONS,
  THEME_COLOR_OPTIONS,
} from "@/v2-backoffice-client/settings/settings.config"
import SettingSection from "@/v2-backoffice-client/settings/SettingSection"
import SettingOptionGroup from "@/v2-backoffice-client/settings/SettingOptionGroup"

function SettingTheme() {
  const { theme, setTheme } = useThemeContext()

  return (
    <SettingSection
      title="Theme"
      description="Controls the visual theme of the interface."
    >
      <div className="space-y-5">
        <div>
          <p className="text-xs font-medium text-muted-foreground mb-2">Mode</p>
          <SettingOptionGroup
            options={THEME_MODE_OPTIONS}
            value={theme.mode}
            onChange={(v) => setTheme({ ...theme, mode: v })}
          />
        </div>

        <div>
          <p className="text-xs font-medium text-muted-foreground mb-2">
            Accent Color
          </p>
          <div className="flex items-center gap-2 flex-wrap">
            {THEME_COLOR_OPTIONS.map((opt) => {
              const colorDef = findThemeColorByName(opt.value)
              const activeColor = colorDef?.activeColor[theme.mode]
              const isActive = theme.theme === opt.value

              return (
                <button
                  key={opt.value}
                  type="button"
                  title={opt.label}
                  className={cn(
                    "size-7 rounded-full border-2 transition-transform hover:scale-110",
                    isActive
                      ? "border-foreground scale-110"
                      : "border-transparent",
                  )}
                  style={{
                    backgroundColor: activeColor
                      ? `hsl(${activeColor})`
                      : undefined,
                  }}
                  onClick={() => setTheme({ ...theme, theme: opt.value })}
                />
              )
            })}
          </div>
        </div>
      </div>
    </SettingSection>
  )
}

export default SettingTheme
